import { Component, ViewChild, OnInit, ElementRef, HostListener, PLATFORM_ID, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Utils } from '../../shared/utils';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MobileNavbar } from '../../layout/mobile-navbar/mobile-navbar.component';
import { clearSessionAuthToken, getStoredAuthToken } from '../../core/auth/auth-token';
import { LanguageSelectorComponent } from '../designs/language-selector/language-selector.component';
import { LanguageService } from '../../core/services/language/language.service';
import { NavSearchComponent } from '../designs/nav-search/nav-search.component';

@Component({
  standalone: true,
  selector: 'app-normal-navbar',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MobileNavbar,
    LanguageSelectorComponent,
    NavSearchComponent
  ],
  templateUrl: './normal-navbar.html',
  styleUrl: './normal-navbar.scss'
})
export class NormalNavbar implements OnInit {

  @ViewChild('profileImage') profileImg!: ElementRef<HTMLImageElement>
  private readonly platformId = inject(PLATFORM_ID);
  public readonly languageService = inject(LanguageService);

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private utils: Utils,
    private el: ElementRef
  ) {}

  authToken: any = '';
  backendUrl: string = environment.backendUrl;
  frontendUrl: string = environment.frontendUrl;
  userDetails: any = null;
  showProfileDropdown = false;
  activeDropdown: string | null = null;

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.authToken = getStoredAuthToken();
    this.getUserDetails();
  }

  private profileLeaveTimer: any = null;

  @HostListener('document:click', ['$event'])
  onDocClick(event: Event): void {
    if (!this.el.nativeElement.contains(event.target)) {
      if (this.profileLeaveTimer) {
        clearTimeout(this.profileLeaveTimer);
        this.profileLeaveTimer = null;
      }
      this.showProfileDropdown = false;
      this.activeDropdown = null;
    }
  }

  toggleProfileDropdown(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.profileLeaveTimer) {
      clearTimeout(this.profileLeaveTimer);
      this.profileLeaveTimer = null;
    }
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  onProfileMouseEnter(): void {
    if (this.profileLeaveTimer) {
      clearTimeout(this.profileLeaveTimer);
      this.profileLeaveTimer = null;
    }
  }

  onProfileMouseLeave(): void {
    if (this.profileLeaveTimer) {
      clearTimeout(this.profileLeaveTimer);
    }
    this.profileLeaveTimer = setTimeout(() => {
      this.showProfileDropdown = false;
    }, 350);
  }

  getUserDetails() {
    const url = this.authToken && this.authToken !== 'undefined' && this.authToken !== 'null'
      ? `${this.backendUrl}/auth/session?session_token=${this.authToken}`
      : `${this.backendUrl}/auth/session`;

    this.http.get(url).subscribe({
      next: (res) => {
        this.userDetails = res;
        if (this.userDetails?.profile_picture) {
          this.userDetails.profile_picture = this.userDetails.profile_picture.replace('=s96-c', '');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.userDetails = null;
        this.handleSessionError(error);
      }
    });
  }

  private handleSessionError(error: HttpErrorResponse): void {
    if (!isPlatformBrowser(this.platformId)) return;
    clearSessionAuthToken();
    this.authToken = '';
  }

  logout() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.showProfileDropdown = false;

    sessionStorage.setItem('pending_toast', JSON.stringify({ type: 'info', title: 'See you later!', message: 'You have been signed out. Come back soon!' }));

    const logoutUrl = this.authToken
      ? `${this.backendUrl}/auth/session/logout?session_token=${this.authToken}`
      : `${this.backendUrl}/auth/session/logout`;

    this.http.get(logoutUrl).subscribe({
      next: () => {
        clearSessionAuthToken();
        location.assign('/');
      },
      error: () => {
        clearSessionAuthToken();
        location.assign('/');
      }
    });
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/images/avatar.png';
  }

  profileNameFilter(name: string): string {
    return (name && this.utils.userProfileNameFilter(name)) || name || 'user';
  }
}
